import React from "react";
import Preloader from "./Preloader/Preloader";

const Spinner = () => {
  return <Preloader />;
};

export default Spinner;
